import React, { Component, useEffect, useState } from "react"
import styled from "styled-components"
import * as BiIcon from "react-icons/bi";


const Navbar = (props) => {

  const [scrolling, setScrolling] = useState(false);

  const { children, onMouseLeave } = props
  const NavbarEl = styled.nav`
  margin: auto;
  position: fixed;
  z-index:100;

  `

  const NavbarList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
`

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  return (

    <NavbarEl onMouseLeave={onMouseLeave} className={scrolling ? 'ScroolNavbar' : 'ScroolNavbar'}>
      <NavbarList >{children} </NavbarList>
   

    </NavbarEl>
  )


}
export default Navbar;
